import axios from "axios";
import {
  getCurrentDate,
} from "@components/Common/Function";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const getWssWssInBlockApi = async () => {
  const currentDate = getCurrentDate();
  // const currentDate = getOneDayBeforeDate();

  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/wss/get-wss-wss-in-block`,
    method: "post",
    headers: headers,
    data: { currentDate },
  };

  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
